var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgKlm(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "64px",
    height: "64px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "KLM") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "KLM",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "#00A1E4",
    cx: 32,
    cy: 32,
    r: 32
  }), /*#__PURE__*/React.createElement("g", {
    id: "klm",
    transform: "translate(8.000000, 17.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.3214035,0 L25.4035088,0 C25.4287719,1.04701754 25.4259649,2.09122807 25.4203509,3.13824561 C26.4505263,3.1354386 27.4835088,3.14105263 28.5136842,3.13263158 C28.5221053,4.16 28.5221053,5.18736842 28.4912281,6.21473684 C27.4694737,6.21473684 26.4449123,6.22035088 25.4231579,6.21473684 C25.4231579,7.22526316 25.4203509,8.23859649 25.4287719,9.25192982 C24.4126316,9.31649123 23.3964912,9.30245614 22.3803509,9.29403509 C22.3747368,8.26666667 22.3747368,7.23649123 22.3691228,6.20631579 C21.3361404,6.22035088 20.3059649,6.21473684 19.2757895,6.21754386 C19.2589474,5.19298246 19.2617544,4.16561404 19.2589474,3.14105263 C20.2975439,3.13824561 21.3361404,3.1354386 22.3719298,3.14105263 C22.3494737,2.09403509 22.4421053,1.04140351 22.3214035,0 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.47438596,8.67649123 C7.57894737,7.92982456 10.9866667,10.5122807 10.9192982,13.7431579 C11.1578947,16.5670175 8.6877193,19.2140351 5.87789474,19.2673684 C3.36,19.4835088 0.895438596,17.6280702 0.364912281,15.1691228 C-0.412631579,12.3564912 1.61964912,9.20701754 4.47438596,8.67649123 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8168421,8.67087719 C19.9185965,7.9354386 23.3375439,10.5235088 23.2505263,13.754386 C23.5003509,16.6596491 20.8561404,19.3515789 17.9677193,19.2757895 C15.4189474,19.3852632 13.0385965,17.3838596 12.637193,14.877193 C12.0673684,12.1235088 14.0575439,9.1845614 16.8168421,8.67087719 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.1649123,8.67649123 C32.1740351,7.96070175 35.4610526,10.3663158 35.5761404,13.4792982 C35.8175439,15.5929825 34.6077193,17.7178947 32.7298246,18.6807018 C30.7564912,19.7445614 28.1431579,19.3684211 26.5347368,17.8133333 C24.7298246,16.1235088 24.3536842,13.1480702 25.7066667,11.0736842 C26.4673684,9.84701754 27.7417544,8.94877193 29.1649123,8.67649123 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5326316,8.67087719 C44.2301754,8.0645614 47.1550877,9.90877193 47.7754386,12.6035088 C48.317193,14.6778947 47.4919298,17.0105263 45.7431579,18.2596491 C44.1178947,19.4722807 41.7852632,19.6238596 40.0168421,18.6329825 C38.085614,17.6308772 36.9375439,15.354386 37.2715789,13.2070175 C37.5270175,10.9922807 39.3347368,9.06105263 41.5326316,8.67087719 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.46526316,27.0540351 C5.38666667,24.9094737 5.42315789,22.7592982 5.44561404,20.6147368 C17.7880702,20.6512281 30.1305263,20.6231579 42.4729825,20.6287719 C42.4757895,22.7649123 42.4757895,24.8982456 42.4729825,27.0315789 C30.1361404,27.045614 17.7992982,27.0035088 5.46526316,27.0540351 Z",
    id: "Path"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlm);
export default __webpack_public_path__ + "static/media/klm.081b0dc9ffa950ee5073df5f49581c7f.svg";
export { ForwardRef as ReactComponent };